import Transfer from './src/transfer.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToTransfer: SFCWithInstall<typeof Transfer> = withInstall(Transfer)

export * from './src/instance'
